import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordContext } from 'react-admin';
import { Avatar } from 'shared/mui/Avatars';
import { Badge } from 'shared/mui/Badge/Badge';
import { Tooltip } from 'shared/mui/Tooltip';
import { RoleEntity } from 'types/embedded/role';
import { User } from 'types/embedded/user';

import { SmallAvatar } from './UserBadgeField.styled';

export type UserBadgeFieldProps = {
  firstName: string;
  lastName: string;
};

type RecordWithUser = {
  user?: User;
} & Record<string, any>;

export const UserBadgeField: React.FC<UserBadgeFieldProps> = ({ firstName, lastName }) => {
  const { hasResourceAccess } = usePermissions();

  const record = useRecordContext<RecordWithUser>();

  const user: User | undefined = (record as User)?.roleEntities ? (record as User) : record?.user;
  const role: RoleEntity | undefined = user?.roleEntities?.[0];

  const getRoleImg = (role: RoleEntity) => {
    if (!role?.roleCategories) {
      return null;
    }

    return (
      <Tooltip arrow title={role.name}>
        <SmallAvatar src={role.roleCategories.description} />
      </Tooltip>
    );
  };
  return (
    <Badge
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={hasResourceAccess(Resources.Roles) && role ? getRoleImg(role) : null}
      overlap="circular"
      sx={{}}
    >
      <Avatar>{`${firstName[0]}${lastName[0]}`.toUpperCase()}</Avatar>
    </Badge>
  );
};
